import FETCH from "../utils/fetch";
import ROUTES from "../config/routes";

const RAG_STREAM_SEARCH_URL =
  "https://54xwsmb6yza3zoiurmyxxjfage0pdiwl.lambda-url.us-east-1.on.aws";

const getAuthHeaders = () => {
  const token = localStorage.getItem("userLoginToken");
  const headers = {
    "Content-Type": "application/json",
    Accept: "text/event-stream, application/json, text/plain, */*",
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return headers;
};

const ingestDocumentRAG = async (body) => {
  const res = await FETCH.post({
    url: `${ROUTES.RAG_DOCUMENT_INJESTION}`,
    body,
  });

  return res;
};

const searchDocumentsRAG = async (body) => {
  const res = await FETCH.post({
    url: `${ROUTES.RAG_DOCUMENT_SEARCH}`,
    body,
  });

  return res;
};

const streamSearchDocumentsRAG = async (body, options) => {
  const fetchOptions = options || {};

  return fetch(RAG_STREAM_SEARCH_URL, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify(body),
    signal: fetchOptions.signal,
  });
};

const RAG_API = {
  ingestDocumentRAG,
  injestDocumentRAG: ingestDocumentRAG,
  searchDocumentsRAG,
  streamSearchDocumentsRAG,
};
export default RAG_API;
